/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const FlexDTO = {
    ask: 'ask',
    deny: 'deny',
    buy: 'buy'
} as const;
export type FlexDTO = typeof FlexDTO[keyof typeof FlexDTO];

